import React from 'react';
import PropTypes from 'prop-types';

import { parseISO, formatDistanceToNow } from 'date-fns';
import pt from 'date-fns/locale/pt';

import Icon from '@material-ui/core/Icon';
import { IoMdCalendar } from 'react-icons/io';

import { Container, Footer, Text, Date, DateText } from './styles';

function InfusionItem({ item, setActive }) {
  const { created_at } = item;
  const { factor } = item.drug;

  const dateParsed = formatDistanceToNow(parseISO(created_at), {
    locale: pt,
    addSuffix: true,
  });

  return (
    <Container onClick={() => setActive(item)}>
      <Icon className="icon-infusion" />
      <Footer>
        <Text>{factor.replace('CONCENTRADO DE ', '')}</Text>
        <Date>
          <IoMdCalendar color="#0384ac" />
          <DateText>{dateParsed}</DateText>
        </Date>
      </Footer>
    </Container>
  );
}

InfusionItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    created_at: PropTypes.string,
    drug: PropTypes.shape({
      factor: PropTypes.string,
    }),
  }).isRequired,
  setActive: PropTypes.func.isRequired,
};

export default InfusionItem;
